import { i18n } from '../i18n'

export const LIMIT_OPS = Object.freeze({
  payment: 'paymentOut',
  withdrawal: 'withdraw',
  deposit: 'deposit'
})

export const LIMIT_OPS_STR = Object.freeze({
  payment: i18n.operation_type_outgoing_payment(),
  withdrawal: i18n.operation_type_withdrawal(),
  deposit: i18n.operation_type_deposit()
})

export const LIMITS_REQUEST_TYPE = Object.freeze({
  initial: 'initial',
  docsUploading: 'docsUploading'
})

export const LIMITS_REQUEST_TYPE_STR = Object.freeze({
  initial: 'Initial',
  docsUploading: 'Documents uploading'
})

export const transactionType = Object.freeze({
  transfer: 23,
  withdrawal: 7
})

export const transactionTypeDescription = Object.freeze({
  transfer: 'transfer',
  withdrawal: 'withdrawal'
})



// WEBPACK FOOTER //
// ./src/js/const/limits.const.js